import React, { useEffect, useState } from 'react';
import { windowWrapper } from '@clubmed/utils';

import { getTabsMainId, getTabsItemIds } from 'Components/utils/tabs/tabs.util';
import { goToHash } from 'Components/utils/scroll/scrollToHash';

function getWithIds({ id, items = [] }) {
  const mainId = id || getTabsMainId(items);

  const itemsWithIds = items.map((item, index) => {
    const [headerId, panelId] = getTabsItemIds({
      id: item.id,
      index,
      mainId,
      title: item.header && item.header.title,
    });
    return { ...item, headerId, panelId };
  });

  return [mainId, itemsWithIds];
}

/* scroll to Tabs or Accordion item #id and open it */
export function withOpenAndScrollToHash(WrappedComponent) {
  return function OpenTabAndScrollToHash(props) {
    const [{ initialSelectedItem, initialSelectedItems }, setIntialItems] = useState({
      initialSelectedItem: props.initialSelectedItem,
      initialSelectedItems: props.initialSelectedItems,
    });
    const [mainId, itemsWithIds] = getWithIds({ id: props.id, items: props.items });

    useEffect(
      () => {
        const hash = windowWrapper.getLocationPart('hash');

        if (hash.length < 2) {
          setIntialItems({
            initialSelectedItem: props.initialSelectedItem,
            initialSelectedItems: props.initialSelectedItems,
          });
          return;
        }

        const ids = itemsWithIds.map(({ headerId = '' }) => `#${headerId}`);
        const index = ids.indexOf(hash);

        if (index !== -1) {
          setIntialItems({ initialSelectedItem: index, initialSelectedItems: [index] });
          setTimeout(() => {
            goToHash(hash);
          }, 250);
        }
      },
      [props.initialSelectedItem, props.initialSelectedItems],
    );

    return (
      <WrappedComponent
        {...props}
        id={mainId}
        initialSelectedItems={initialSelectedItems}
        initialSelectedItem={initialSelectedItem}
        items={itemsWithIds}
        key={mainId} // to reinitialize state when it is new tabs, see : https://fr.reactjs.org/blog/2018/06/07/you-probably-dont-need-derived-state.html#recommendation-fully-uncontrolled-component-with-a-key
      />
    );
  };
}
